import axios from "axios";
import config from "../config/constants";
import store from "../store";

export const customLog = async data => {
  const message = JSON.stringify(
    {
      ...data,
      source: "AXA-WEB"
    },
    null,
    2
  );

  const base64Message = btoa(message);

  const payload = {
    payload: base64Message,
    user_id: store.getters.user_id
  };

  try {
    const response = await axios.post(
      `${config.api_env}/application/api/i/log/insert`,
      payload,
      config.options
    );

    if (response.data === true) {
      throw new Error();
    }
  } catch (error) {
    console.error(
      "Error logging custom event:",
      JSON.parse(message)?.event || "",
      error
    );
  }
};

export default customLog;
